module.exports = __webpack_public_path__ + "static/media/save-wallet.17a2485a.svg";